import snsAxiosClient from '../common/http/http-sns';
import formatString from '../utils/formatString';
import { get } from 'lodash';

/**
 * expected response:
 * {
 *     store: {
 *         ecomStore: {
 *             storeFeatures: {
 *                 isAutoReplenishmentEnabled: boolean
 *             }
 *         }
 *     }
 * }
 *
 * @param environmentVariables
 * @param user
 * @param storeId
 */
function storeDetailsService(environmentVariables, user, storeId: string) {
  const options = {
    headers: {
      ...get(environmentVariables, 'STORE_LOOKUP_API_HEADERS_GET_V1', ''),
      Authorization: `Bearer ${get(user, 'authToken')}`,
    },
  };
  return snsAxiosClient(options).get(
    formatString(get(environmentVariables, 'SNS_STORE_DETAILS', 'store_details'), {
      storeId,
    }),
  );
}

export default storeDetailsService;
